export default __webpack_public_path__ + "img/5822d431c3d291f7d0027349f6b20c55.svg";